import React from "react";
import { StatusChip, StatusChipProps } from "./StatusChip";

// TODO: This component needs a complete rework once legacy support is no longer required

interface StatusChipsProps {
  statusChipsProps: StatusChipProps[];
}

export const StatusChips = (props: StatusChipsProps) => {
  return (
    <>
      {props.statusChipsProps.map((statusChip, index) => (
        <StatusChip
          status={statusChip.Status ?? statusChip.status}
          label={statusChip.Text ?? statusChip.label}
          toolTip={statusChip.toolTip}
          icon={statusChip.icon}
          key={"statusChips" + index}
        />
      ))}
    </>
  );
};
